import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ExternalVendorFacadeService } from '@usf/ngrx-product';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExternalVendorResolverService {
  constructor(private externalVendorFacade: ExternalVendorFacadeService) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): any {
    this.externalVendorFacade.loadVendors();
  }
}
